import React from 'react';

const Session = () => {
    return (
        <div>
            Session
        </div>
    );
};

export default Session;
